import React, {
  forwardRef,
  memo,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Col, Row, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import Clear from "@mui/icons-material/Clear";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./DashboardShortcuts.css";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import interactive from "../../../Assets/Images/map.png";
import pdf from "../../../Assets/Images/pdf-icons.png";
import summary from "../../../Assets/Images/summary.png";
import developtransaction from "../../../Assets/Images/developments-transactions-icon.png";
import parks from "../../../Assets/Images/parks.png";
import Snackbar from "@mui/material/Snackbar";
import { handlingCatchError } from "../../../Utils/ErrorHandling";

import axios from "axios";
import StoreIcon from "@mui/icons-material/Store";
import Tooltip from "@mui/material/Tooltip";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
let nationalDemandScore = null;
// let marketDetails = [];
import {DashboardSummary} from "./DashboardSummary/Index";
import RVParksList from "./RVParksList/RVParksList";
import { InteractiveMap } from "./InteractiveMap/Index";
import { KnownDevelopments } from "./KnownDevelopments/Index";
import { useParams } from 'react-router-dom';
import { apiCommonTrigger, apiCommonTriggerBlob } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";

const DashboardShortcuts = forwardRef((props, ref) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isFrom = location.pathname.substring(0,location.pathname.lastIndexOf("/")+1);
  const [isDownload, setOpenDownload] = useState(false);
  // const isLoading = props.loading;
  const [snack, setSnackOpen] = useState({ snackOpen: false, snackMsg: "" });
  const apiPath = process.env.REACT_APP_API_URL;
  const [marketDetails, setMarketDetails] = useState({});
  const marketId = location.pathname.split("/").pop();
  const [mapDataLoader, setMapDataLoader] = useState(false);
  const { id } = useParams();

  // //get interactive map data
  const getMapData = async (profileId) => {
    setMapDataLoader(true);
    await apiCommonTrigger("get" , Config.API_URL + "/markets/market/" , [profileId])
    .then((res) => {
      if (res.status === 200) {
        setMarketDetails(res.data);
        setMapDataLoader(false);
      } 
      
      else{
        if (res.status === 500) {
          if(res.data === "No market found"){
            setMapDataLoader(false);
            setMarketDetails('');
            navigate("/invalid-access-dashboard");
          }
        }
        setMapDataLoader(false);
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      setMapDataLoader(false);
      handlingCatchError(err, navigate);
    })
  };

  useEffect(() => {
    if (id) { getMapData(id) }
  }, [id]);

  //download summary report
  const downloadSummaryReport = () => {
    //setLoading(true);
    var timestamp =
      new Date().getDate() +
      "" +
      new Date().getMonth() +
      "" +
      new Date().getFullYear() +
      "" +
      new Date().getTime();
    var fileName = "RVParkIQ" + "_SummaryReport_" + timestamp + ".pdf";
    var alertMsg =
      "Your download is being processed. The " +
      fileName +
      " file will be download automatically to your browser when ready. Please do not close or refresh the window until the download is complete. We recommend you check your Downloads folder if you don’t see it in your browser.";
    setSnackOpen({
      ...snack,
      snackOpen: true,
      snackMsg: alertMsg,
    });

    let payload = { marketId: marketId ? marketId : null, fileName: fileName }
    apiCommonTriggerBlob("post",`${Config.API_URL}/markets/market/report/summary`, payload).then((res) => {
        // setLoading(false);
        if (res.status === 200) {
          setOpenDownload(false);
          //create link and make a file download
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          //this.setState({ link })
          link.click();
        } else if (res.status === 401) {
          navigate("/");
        }
      })
      .catch((err) => {
        handlingCatchError(err);
      });
    };

  const priceConversion = (tot) => {
    if (tot === null || tot === undefined)
      return '-';

    if (tot !== "") {
      let checkDigit = tot.toString().split(".");
      let ret = "";
      let i = 0;
      if (tot.toString().indexOf(".") == -1) {
        tot = tot;
      } else {
        if (checkDigit == "00") {
          tot = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }
          }
          ret = ret.toString();
          tot = ret;
        }
      }
    }
    return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  //download detail report
  const downloadDeatilReport = () => {
    // setLoading(true);
    var timestamp =
      new Date().getDate() +
      "" +
      new Date().getMonth() +
      "" +
      new Date().getFullYear() +
      "" +
      new Date().getTime();
    var fileName = "RVParkIQ" + "_DetailReport_" + timestamp + ".pdf";
    var alertMsg =
      "Your download is being processed. The " +
      fileName +
      " file will download automatically to your browser when ready. Please do not close or refresh the window until the download is complete. We recommend you check your Downloads folder if you don’t see it in your browser.";
    setSnackOpen({
      ...snack,
      snackOpen: true,
      snackMsg: alertMsg,
    });
    var userDetails =
      localStorage.getItem("user") !== null
        ? localStorage.getItem("user")
        : null;
    var token =
      userDetails !== null && JSON.parse(userDetails).token !== null
        ? JSON.parse(userDetails).token
        : "";
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;

    const requestData = {
      marketId: marketId ? marketId : null,
      fileName: fileName,
    };
 apiCommonTriggerBlob("post",`${Config.API_URL}/markets/market/report/detail`,requestData).then((res) => {
      // setLoading(false);
      if (res != undefined) {
        if (res.status === 200) {
          setOpenDownload(false);
          //create link and make a file download
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        } else if (res.status === 401) {
          navigate("/");
        } else {
        }
      }
    })
    .catch((err) => {
      handlingCatchError(err);
    }); 
  };

  //snack bar open/close
  const snackHandleclose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ ...snack, snackOpen: false, snackMsg: "" });
  };

  return (
    <div>
      <React.Fragment>
        <Row className="dashboard-columns m-0">
            <Col className="divided-col p-0 no-link">
              <div className="link-to">
                <div className="middle-div">                  
                  {marketDetails && Object.keys(marketDetails).length > 0 && marketDetails.address &&
                    <div className="other-labels">
                      {marketDetails.marketname && <div className="market-name-label"> {marketDetails.marketname} </div> } 
                        <div className="address">
                        {marketDetails && Object.keys(marketDetails).length > 0 && marketDetails.supplyradius ? 
                          marketDetails.supplyradius + " miles radius around " : ""}

                        {marketDetails && Object.keys(marketDetails).length > 0 && marketDetails.address
                          ? marketDetails.address
                          : ""}
                        </div>
                    </div>
                  }

                  { (marketDetails && Object.keys(marketDetails).length  ===  0 && !marketDetails.address ) && 
                    <div className="loader-wrap-text market-loader"> <div className="loading-text"></div> </div> 
                  }

                </div>
              </div>
            </Col>
          {/* ) : (
            ""
          )} */}
          <Col className="divided-col pe-0 link-box">
            <Link
              id="int-map"
              to={{
                pathname: `/market-dashboard/interactive-map/`+marketId,
              }}
              state={{ marketId: marketId }}
              className={
                isFrom === "/market-dashboard/interactive-map/" ? "link-to active-col" : "link-to"
              }
            >
              <div className="middle-div">
                <div className="other-labels">
                  Interactive Map
                  <img src={interactive} alt="Interactive Map"/>
                </div>
              </div>
            </Link>
          </Col>
          <Col className="divided-col pe-0 link-box">
            <Link
              to={{
                pathname: `/market-dashboard/market-analysis/`+marketId,
              }}
              state={{ marketId: marketId }}
              className={
                isFrom === "/market-dashboard/market-analysis/" ? "link-to active-col" : "link-to"
              }
            >
              <div className="middle-div">
                <div className="other-labels">
                  Market Analysis
                  <img src={summary} alt="Market Analysis" />
                </div>
              </div>
            </Link>
          </Col>
          <Col className="divided-col pe-0 link-box">
            <Link
              id="k-dev"
              to={{
                pathname: `/market-dashboard/known-development/`+marketId,
              }}
              state={{ marketId: marketId }}
              className={
                isFrom === "/market-dashboard/known-development/" ? "link-to active-col" : "link-to"
              }
            >
              <div className="middle-div" style={{paddingTop: '5px', paddingBottom: '7px'}}>
                <div className="dev-values">
                <div className="other-labels" style={{lineHeight: 'normal'}}>
                  Developments {marketDetails?.knowndevelopmentscount ? <span className="circle-count">{marketDetails?.knowndevelopmentscount}</span> : ''} and Transactions {marketDetails?.sourcetransactioncount ? <span className="circle-count circle-two">{marketDetails.sourcetransactioncount}</span> : ''}
                 <img src={developtransaction} alt="Developments and Transactions"/>
                </div>
                </div>
              </div>
            </Link>
          </Col>
          <Col className="divided-col pe-0 link-box">
            <Link
              to={{
                pathname: `/market-dashboard/rvparks-lists/`+marketId,
              }}
              // state={{ marketId: marketId }}
              className={
                isFrom === "/market-dashboard/rvparks-lists/" ? "link-to active-col" : "link-to"
              }
            >
              <div className="middle-div">
                <div className="other-labels">
                  RV Parks List
                  <img src={parks} alt="RV Parks List" />
                  {marketDetails && marketDetails.rvparkscount > 0 ?<span className="circle-count">{marketDetails.rvparkscount}</span>:''}
                </div>
              </div>
            </Link>
          </Col>
          <Col className="divided-col pe-0 link-box">
            <label
              onClick={() => setOpenDownload(!isDownload)}
              className={
                props.isFrom === "report" ? "link-to active-col" : "link-to"
              }
            >
              <div className="middle-div">
                <div className="other-labels">
                  Download Report
                  <img src={pdf} alt="Download Report"/>
                </div>
              </div>
            </label>
            <Modal
              backdrop="static"
              isOpen={isDownload}
              className="download-popup"
            >
              <ModalHeader>
                {" "}
                Download Report{" "}
                <Clear
                  onClick={() => setOpenDownload(!isDownload)}
                  className="close-icon"
                />
              </ModalHeader>
              <ModalBody>
                <Button
                  onClick={() => downloadSummaryReport()}
                  className="summary-report-btn"
                >
                  Download for Summary Report
                </Button>
                <Button
                  onClick={() => downloadDeatilReport()}
                  className="detailed-report-btn"
                >
                  Download for Detailed Report
                </Button>
              </ModalBody>
            </Modal>
          </Col>
        </Row>

        {(marketDetails && marketDetails.marketdemandformarket !== null && !mapDataLoader ) || (marketDetails && marketDetails.rvparkdemandscoreformarket !== null && !mapDataLoader ) || (marketDetails && marketDetails.demandsupplyratioformarket !== null && !mapDataLoader) ?
          <Row className="detail-market-score">
            {marketDetails && marketDetails.marketdemandformarket !== null ?
              <Col md={4} className="one-score">

                <div className="score-details">
                  <div className="inline-flex label-score">
                    <b>Potential Campers</b>
                  </div>
                  <div className="inline-block">
                    <b>{marketDetails.marketdemandformarket} %</b> of the market camps
                    <div><b>{marketDetails.marketdemandfornational} %</b> of the nation camps</div>
                  </div>
                </div>

              </Col>
              : ""
            }
            {marketDetails && marketDetails.rvparkdemandscoreformarket !== null && marketDetails.rvparkdemandscorefornational !== null ?
              <Col md={4} className="two-score">
                <div className="score-details">
                  <div className="inline-flex label-score">
                    <Tooltip title="Camping Demand based on Proximity, Income, Ethnicity, and Age" placement="top" arrow>
                      <b>Potential Campers based on Demand<InfoOutlined className="info-tooltip" /></b>
                    </Tooltip>
                  </div>
                  <div className="inline-block">
                    <b>{priceConversion(marketDetails.rvparkdemandscoreformarket)}</b> market potential campers
                    <div><b>{priceConversion(marketDetails.rvparkdemandscorefornational)}</b> national average of potential campers</div>
                  </div>
                </div>
              </Col>
              : ""
            }
            {marketDetails && marketDetails.demandsupplyratioformarket !== null ?
              <Col md={4} className="three-score">
                <div className="score-details">
                  <div className="inline-flex label-score">
                    <Tooltip title="Number of Campers per Camping Spots." placement="top" arrow>
                      <b>Campers per Camping Spots<InfoOutlined className="info-tooltip" /></b>
                    </Tooltip>
                  </div>
                  <div className="inline-block">
                    <b>{marketDetails.demandsupplyratioformarket}</b> market ratio
                    <div><b>{marketDetails.demandsupplyratiofornational}</b> national ratio</div>
                  </div>
                </div>
              </Col>
              : ""
            }
            <Col md={12}>
              <p className="info-msg-us">*Demographic data based on U.S. Census Bureau's 2023 American Community Survey</p>
            </Col>
          </Row>
          : mapDataLoader ? <Row className="detail-market-score"><p className="text-center p-3">We are calculating the market score...</p></Row> : ''
        }
        <Row>
          <Col>
          {isFrom === "/market-dashboard/market-analysis/"?
            <DashboardSummary data={marketDetails} marketId={marketId}  />
          :
          isFrom === "/market-dashboard/rvparks-lists/" ?
          <RVParksList data={marketDetails} marketId={marketId} getBasicDetails={getMapData} />
          : isFrom === "/market-dashboard/interactive-map/" ?
          <InteractiveMap data={marketDetails} marketId={marketId} getBasicDetails={getMapData} />
          : isFrom === "/market-dashboard/known-development/" ?
          <KnownDevelopments data={marketDetails} marketId={marketId} getBasicDetails={getMapData} />
          :<p className="text-center">Loading...</p>}
          </Col>
        </Row>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={snack.snackOpen}
          id="snack-success"
          className="snack-bar custom-snackbar"
          maxsnack={3}
          autoHideDuration={5000}
          onClose={snackHandleclose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{snack.snackMsg}</span>}
          action={[
            <Clear
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={snackHandleclose}
            />,
          ]}
        />
      </React.Fragment>
    </div>
  );
});

export default DashboardShortcuts;
